import { useInfiniteQuery } from '@tanstack/react-query'
import { api } from '@api'
import { ContactRequestFilterType } from '@hooks'

export type RequestedContactUser = {
  id: string
  fullName: string
  avatarUrl: string
}

export interface RequestedContact {
  id: string
  status: 'PENDING' | 'ACTIVE' | 'COMPLETED' | 'CANCELLED'
  recipient: RequestedContactUser
  sender: RequestedContactUser
  createdAt: string
  updatedAt: string
}

interface RequestedContactPage {
  data: RequestedContact[]
  metadata: {
    count: number
    limit: number
    page: number
  }
}

interface FetchParams {
  type: ContactRequestFilterType
  pageParam?: string | number
}

const fetchRequestedContacts = async ({
  type,
  pageParam = '1',
}: FetchParams): Promise<RequestedContactPage> => {
  const url = `/contact-requests?type=${type}&page=${pageParam}`
  const { data } = await api.get<RequestedContactPage>(url)
  return data
}

export const usePaginateRequestedContacts = (type: ContactRequestFilterType) => {
  return useInfiniteQuery<RequestedContactPage, Error>({
    queryKey: ['contacts-requested-' + type],
    queryFn: ({ pageParam }) =>
      fetchRequestedContacts({ type, pageParam: pageParam as string | number | undefined }),
    getNextPageParam: ({ metadata: { count, limit, page } }) => {
      const totalPages = Math.ceil(count / limit)

      if (page < totalPages) {
        return page + 1
      }

      return undefined
    },
    initialPageParam: '1',
  })
}
